import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", { d: "M7.49922 6.29999L1.89922 0.599988C1.49922 0.199988 0.899219 0.199988 0.499219 0.599988C0.0992189 0.999988 0.0992189 1.59999 0.499219 1.99999L5.39922 6.89999L0.499219 11.8C0.299219 12 0.199219 12.2 0.199219 12.5C0.199219 13.1 0.599219 13.5 1.19922 13.5C1.49922 13.5 1.69922 13.4 1.89922 13.2L7.59922 7.49999C7.89922 7.29999 7.89922 6.69999 7.49922 6.29999Z" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_base_svg = _resolveComponent("base-svg")!

  return (_openBlock(), _createBlock(_component_base_svg, {
    width: _ctx.width,
    height: _ctx.height,
    fill: _ctx.fill,
    viewBox: _ctx.viewBox
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["width", "height", "fill", "viewBox"]))
}